import { CdkDrag, CdkDragDrop } from "@angular/cdk/drag-drop"
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild, ViewEncapsulation } from "@angular/core"
import { IActorDto } from "core/dto"
import { subjectFromObs } from "core/rx-js"
import { BehaviorSubject, Subject, distinctUntilChanged, filter, fromEvent, map, switchMap, take, takeUntil } from "rxjs"
import { IActivity } from "../../../../dto-map/i-activity"
import { SelectActivitiesStepService } from "../../select-activities-step.service"
import { ActivityCollectionService } from "../activity-collection.service"
import { ActivityItemService } from "./activity-item.service"



export type SignerItemColor =
  'group' |
  'placeholder' |
  'dragPreview'

export type Move = {
  fromGroupIdx: number,
  fromItemIdx: number,

  toGroupIdx: number,
  toItemIdx: number,

  activityId: number
  type: 'afterItem' |
  'beforeItem' |
  'beforeGroup' |
  'afterGroup'

  activity: IActorDto,

  activityNativeElement: HTMLElement

}

@Component({
  selector: 'ss-activity-item',
  templateUrl: './activity-item.component.html',
  styleUrls: ['./activity-item.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    ActivityItemService
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ActivityItemComponent implements OnInit {

  private readonly _destroy = new Subject<void>();
  readonly ITEM_HEIGHT = 75;

  private _activity!: IActivity
  @Input() get activity() {
    return this._activity;
  }
  set activity(value) {
    this._activity = value;
    this._changeDetectorRef.detectChanges();
  }

  readonly activityIdSubject = this._activityItemService.activityIdSubject;
  @Input() get activityId() {
    return this.activityIdSubject.value;
  }
  set activityId(value) {
    this.activityIdSubject.next(value);
  }

  @ViewChild(CdkDrag)
  private _cdkDrag!: CdkDrag

  @ViewChild('handleWrapper', { read: ElementRef<HTMLElement> })
  private _handle!: ElementRef<HTMLElement>
  readonly handleSubject = new BehaviorSubject<HTMLElement>(null)
  readonly splugInfoOpenedSubject = this._activityItemService.splugInfoOpenedSubject;
  readonly mainFormGroupSubject = this._activityItemService.mainFormGroupSubject;
  readonly activitiesSubject = this._activityCollectionService.activitiesSubject;
  readonly showErrorObs = this._activityItemService.showErrorObs;
  readonly moveSubject = this._activityCollectionService.moveSubject;

  readonly groupHasMultipleItemsObs = this.activitiesSubject.pipe(
    map(activities => activities?.filter(({ orderIndex }) => this.activity?.orderIndex === orderIndex).length > 1)
  )
  readonly showMergeOverlay = new Subject<boolean>();

  readonly dragModeSubject = subjectFromObs({
    initialValue: false,
    observable: this.handleSubject.pipe(
      filter(Boolean),
      switchMap(handle =>
        fromEvent(document, 'mousemove').pipe(
          map((ev: MouseEvent) => {
            const position = {
              x: ev.clientX,
              y: ev.clientY
            }
            const { x, y, height, width } = handle.getBoundingClientRect();

            return position.x > x && position.x < (x + width)
              && position.y > y && position.y < (y + height)
          }),
        )
      ),
      distinctUntilChanged()
    ),
    until: this._destroy
  })

  constructor(
    private _activityCollectionService: ActivityCollectionService,
    private _activityItemService: ActivityItemService,
    private _selectActivitiesStepService: SelectActivitiesStepService,
    private _changeDetectorRef: ChangeDetectorRef
  ) {


    this.mainFormGroupSubject
      .pipe(
        filter(Boolean),
        take(1)
      )
      .subscribe((mainFormGroup) =>
        this._selectActivitiesStepService.addForm(mainFormGroup)
      )


    this.dragModeSubject.subscribe((dragMode) => {

      this._activityCollectionService.dragModeSubject.next(dragMode)
    })

  }

  ngOnInit(): void {

  }

  ngAfterViewInit() {


    this._cdkDrag.data = this;

    this._cdkDrag.moved
      .pipe(takeUntil(this._destroy))
      .subscribe((evParams) => {
        this.moveSubject.next(evParams)

      })


    this.handleSubject.next(this._handle?.nativeElement)

  }

  drop(event: CdkDragDrop<any>) {
    this._activityCollectionService.dropSubject.next(event)

  }


  toggleExpanded() {

  }

  removeActivity() {

    this._activityCollectionService.remove(this.activityId || '');

    const mainFormGroup = this.mainFormGroupSubject.value;
    this._selectActivitiesStepService.removeForm(mainFormGroup);
  }


  ngOnDestroy() {
    this._destroy.next();
    this._destroy.complete();

    this.showMergeOverlay.complete();
    this._selectActivitiesStepService.removeForm(this.mainFormGroupSubject.value);

  }

}
